import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useState } from "react";

const PrintDivById = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handlePrint = async () => {
    if (isProcessing) return; // Prevent multiple triggers
    setIsProcessing(true);

    const printContent = document.getElementById("print-area");
    if (printContent) {
      try {
        // Use html2canvas to capture the div as a canvas
        const canvas = await html2canvas(printContent, { scale: 2 }); // Double the resolution
        const imgData = canvas.toDataURL("image/png");

        // Define the target paper size in mm
        const paperWidth = 58; // Fixed paper width in mm
        const paperHeight = 100; // Fixed paper height in mm
        const pdf = new jsPDF("p", "mm", [paperWidth, paperHeight]);

        // Fit the image to the page
        const aspectRatio = canvas.width / canvas.height;
        let imgWidth = paperWidth; // Fit width
        let imgHeight = paperWidth / aspectRatio; // Adjust height to maintain aspect ratio

        if (imgHeight > paperHeight) {
          imgHeight = paperHeight;
          imgWidth = paperHeight * aspectRatio;
        }

        // Add the image to the PDF
        pdf.addImage(
          imgData,
          "PNG",
          0,
          0,
          imgWidth,
          imgHeight,
          undefined,
          "FAST"
        );

        // Open the print dialog
        pdf.autoPrint();
        window.open(pdf.output("bloburl"), "_blank");
      } catch (error) {
        console.error("Error generating PDF:", error);
      } finally {
        setIsProcessing(false);
      }
    } else {
      alert("No content found to print!");
      setIsProcessing(false);
    }
  };

  return (
    <div>
      <div
        id="print-area"
        style={{
          border: "1px solid #000",
          padding: "40px",
          width: "400px",
          fontWeight: "bold", // Ensures strong text
          color: "#000000", // Ensures solid black color
        }}
      >
        <h2>This is the content to convert to PDF</h2>
        <p>Only this part of the page will be captured as a PDF.</p>
      </div>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault(); // Prevent default anchor behavior
          handlePrint(); // Trigger the print logic
        }}
        style={{
          margin: "20px",
          cursor: isProcessing ? "not-allowed" : "pointer",
          color: isProcessing ? "gray" : "blue",
        }}
      >
        <i className="fas fa-print" />{" "}
        {isProcessing ? "Processing..." : "Print"}
      </a>
    </div>
  );
};

export default PrintDivById;
